import type { ReactNode } from 'react'

/** The page's main landmark, the skip link's target. Every app shell renders
 *  its content inside this (appShellLandmarks.test.ts holds that). */
export function ContentMain({ className = '', children }: { className?: string; children: ReactNode }) {
  return (
    <main id="main" tabIndex={-1} className={`focus:outline-none ${className}`}>
      {children}
    </main>
  )
}
